import { Text } from "../Text";
import { CopyableValue } from "./CopyableValue";
import { DetailLabel, DetailRow } from "./shared";

export function CopyableDetailField({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <DetailRow>
      <DetailLabel style={{ flex: 1, gap: 8 }}>
        <Text variant="text-small-md">{label}</Text>
        <CopyableValue value={value}>
          <Text variant="code-small" ellipsis>
            {value}
          </Text>
        </CopyableValue>
      </DetailLabel>
    </DetailRow>
  );
}
